import Vue from 'vue'
import LogoLarge from '@/components/LogoLarge.vue'
import LogoSmall from '@/components/LogoSmall.vue'
import LanguageDropdown from '@/components/LanguageDropdown.vue'
import AuthLayoutWrapper from '@/layouts/AuthLayoutWrapper.vue'

Vue.component('LogoLarge', LogoLarge)
Vue.component('LogoSmall', LogoSmall)
Vue.component('LanguageDropdown', LanguageDropdown)
Vue.component('AuthLayoutWrapper', AuthLayoutWrapper)
